import { autocompleteClasses } from '@mui/material/Autocomplete';
import { formHelperTextClasses } from '@mui/material/FormHelperText';
import { formLabelClasses } from '@mui/material/FormLabel';
import { iconButtonClasses } from '@mui/material/IconButton';
import { inputBaseClasses } from '@mui/material/InputBase';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { listItemClasses } from '@mui/material/ListItem';
import { menuItemClasses } from '@mui/material/MenuItem';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { createTheme } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';

//http://paletton.com/#uid=43u0I0kKQrYrNFhHRDiNQmIRwh3
//primary: #045B8E
//secondary1: #DFB500
//secondary2: #D90010
//complementary: #DF7B00

const getThemeStyles = (mode) => {
    const isDark = mode !== 'light';
    const isDark2 = mode === 'dark2';

    return ({
    spacing: 4,
    palette: {
        mode: isDark ? 'dark' : 'light',
        primary: {
            main: isDark2 ? '#737c81' : '#045a8e',
            ...(isDark2 ? { contrastText: '#ffffff' } : {})
        },
        secondary: {
            main: '#DFB500'
        },
        error: {
            main: isDark2 ? '#ad5c64' : '#D90010',
            ...(isDark2 ? { dark: '#8c454d', contrastText: '#ffffff' } : {})
        },
        ...(isDark2 ? {
            background: {
                default: '#202326',
                paper: '#2b3034'
            },
            text: {
                primary: '#f0f2f3',
                secondary: '#b7c0c5'
            },
            divider: 'rgba(255, 255, 255, 0.12)',
            action: {
                selected: 'rgba(255, 255, 255, 0.16)',
                hover: 'rgba(255, 255, 255, 0.08)'
            }
        } : {}),
    },
    header: {
        backgroundColor: '#ffffff',
        boxShadow: 'none',
        display: 'flex'
    },
    typography: {

        // fontFamily: [
        //     'Roboto Regular',
        //     '"Segoe UI"',
        // ].join(',')
    },
    components: {
        MuiPaper: {
            styleOverrides: {

            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    color: '#031527 !important',
                }
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    ...(isDark2
                        ? { backgroundColor: '#2b3034' }
                        : isDark
                            ? { backgroundColor: 'rgb(21, 39, 47)' }
                            : {})
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    height: 26,
                    '&:nth-of-type(2n)': {
                        backgroundColor: isDark2
                            ? 'rgba(255, 255, 255, 0.035)'
                            : isDark
                                ? 'rgb(26, 63, 82)'
                                : '#f6f6f6'
                    },
                },
                head: {
                    height: 26,
                    backgroundColor: isDark2 ? '#353b40' : isDark ? undefined : '#eef2f5',
                    backgroundImage: isDark2
                        ? 'linear-gradient(#353b40, #353b40)'
                        : isDark
                            ? 'linear-gradient(rgb(0, 57, 83), rgb(0, 57, 83))'
                            : 'none',
                },
                hover: {
                    '&:hover': {
                        cursor: 'pointer'
                    }
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    fontSize: 16,
                    color: '#031527 !important',
                    textAlign: 'center !important',
                    fontWeight: 'bold !important',
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: undefined,
                    border: isDark2 ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid #031527',
                    padding: `${4}px ${8}px`,
                    '&:last-child': {
                        paddingRight: undefined
                    },
                    verticalAlign: 'unset',
                    '& a:visited': {
                        color: isDark2 ? '#d0d5d8' : isDark ? 'white' : 'rgb(0, 102, 204)'
                    },
                    '& a': {
                        color: isDark2 ? '#d0d5d8' : isDark ? 'white' : 'rgb(0, 102, 204)',
                        textDecoration: isDark ? 'underline' : 'none'
                    }
                },
                head: {
                    color: isDark ? 'white !important' : 'rgba(0, 0, 0, 0.87) !important',
                    fontSize: 16
                },
                stickyHeader: {
                    backgroundColor: isDark2 ? '#353b40' : isDark ? undefined : '#eef2f5',
                    backgroundImage: isDark2
                        ? 'linear-gradient(#353b40, #353b40)'
                        : isDark
                            ? 'linear-gradient(rgb(0, 57, 83), rgb(0, 57, 83))'
                            : 'none',
                    lineHeight: 'initial'
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                toolbar: {
                    minHeight: '32px !important',
                    height: 32,
                    paddingRight: 8
                },
                selectRoot: {
                    marginRight: 24
                },
                selectIcon: {
                    //fontSize: '1.2rem',
                    //position: 'relative',
                    //left: -20
                    top: undefined,
                    ...(isDark ? { color: 'white' } : {})
                },
                select: {
                    //paddingRight: 16
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    lineHeight: undefined,
                    minHeight: 32,
                    [`&.${menuItemClasses.selected}`]: {
                        backgroundColor: isDark2 ? 'rgba(255, 255, 255, 0.16)' : isDark ? 'rgb(0, 98, 143)' : '#cfebff',
                        fontWeight: 600
                    }
                }
            }
        },
        MuiList: {
            styleOverrides: {
                padding: {
                    paddingTop: 4,
                    paddingBottom: 4,
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                marginDense: {
                    marginTop: 4,
                    marginBottom: 4,
                    [`& .${inputLabelClasses.root}`]: {
                        transform: 'translate(8px, 9px) scale(1)',
                        fontSize: 14,
                        color: isDark2 ? 'rgba(255, 255, 255, 0.7)' : isDark ? 'gray' : 'gray'
                    },
                    [`& .${inputBaseClasses.root}`]: {
                        lineHeight: undefined,
                        padding: 4
                    },
                    [`& .${inputBaseClasses.input}`]: {
                        padding: 4,
                        fontSize: 14
                    },
                    [`& .${formHelperTextClasses.root}`]: {
                        marginTop: 2,
                        fontSize: 11
                    }
                },
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                positionEnd: {
                    [`& .${iconButtonClasses.edgeEnd}`]: {
                        padding: undefined,
                        marginRight: 0
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    [`&.${inputLabelClasses.outlined}.${inputLabelClasses.shrink}`]: {
                        color: 'unset',
                        transform: 'translate(14px, -8px) scale(0.8)'
                    },
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    '&:not(.Mui-error)': {
                        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: isDark2 ? '#b4bcc0' : isDark ? 'rgb(4, 90, 142)' : '#031527'
                        },
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: isDark2 ? 'rgba(255, 255, 255, 0.35)' : isDark ? 'rgb(4, 90, 142)' : '#031527'
                        },
                    }
                },
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    [`& .${outlinedInputClasses.root}`]: {
                        padding: 4
                    },
                },
                inputRoot: {
                    [`& .${outlinedInputClasses.input}`]: {
                        padding: 4,
                        [`&.${autocompleteClasses.input}`]: {
                            padding: '4px 4px',
                        },
                    },
                },
                listbox: {
                    padding: '4px 0'
                },
                option: {
                    '&[aria-selected="true"]': {
                        backgroundColor: isDark2 ? 'rgba(255, 255, 255, 0.16) !important' : isDark ? 'rgb(0, 98, 143) !important' : '#cfebff !important',
                        fontWeight: 600
                    }
                },
                paper: {
                    lineHeight: undefined,
                    border: '1px solid #515151'
                },
                endAdornment: {
                    top: 'unset'
                },
                clearIndicator: {
                    [`& .${svgIconClasses.fontSizeSmall}`]: {
                        fontSize: '1rem'
                    }
                }
            }
        },
        PrivateNotchedOutline: {
            root: {
                borderRadius: 1
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    [`&:not(${formLabelClasses.error})`]: {
                        color: isDark2 ? 'rgba(255, 255, 255, 0.7)' : isDark ? 'rgb(4, 90, 142)' : '#031527'
                    }
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    color: isDark2 ? '#f1f5f9' : 'rgba(0, 0, 0, 0.87)',
                    [`&.${listItemClasses.selected}`]: {
                        backgroundColor: isDark2 ? 'rgba(255, 255, 255, 0.16) !important' : isDark ? 'rgb(0, 98, 143) !important' : '#cfebff !important',
                        fontWeight: 600
                    },
                    '& [class*="PrivateSwitchBase-root"]': {
                        padding: 6
                    }
                },
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: 32,
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minHeight: 32,
                    '@media (min-width: 960px)': {
                        minWidth: 100
                    },
                    padding: '4px 8px'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                selectMenu: {
                    display: 'flex',
                    alignItems: 'center'
                },
                icon: {
                    fontSize: '1.2rem',
                    position: 'absolute',
                    right: 8,
                    top: undefined,
                    color: isDark ? 'white' : 'rgba(0, 0, 0, 0.54)',
                    cursor: 'pointer',
                    '&:hover': {
                        color: 'inherit',
                    }
                },
                select: {
                    height: '1rem',
                    lineHeight: '1rem',
                    [`&.${inputBaseClasses.input}`]: {
                        display: 'flex',
                        alignItems: 'center'
                    }
                }
            }
        },
        MuiStepLabel: {
            styleOverrides: {
                iconContainer: {
                    fontSize: '1.2rem'
                }
            }
        },
        MuiStepper: {
            styleOverrides: {
                root: {
                    padding: 16
                }
            }
        },
        MuiSvgIcon: {
            defaultProps: {
                fontSize: 'small'
            },
            styleOverrides: {
                root: {
                    fontSize: undefined
                },
                fontSizeSmall: {
                    fontSize: '1.1rem'
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                h6: {
                    fontSize: '1rem',
                    lineHeight: 1.5
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: isDark2 ? {
                    backgroundColor: '#496878',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#3b5664'
                    }
                } : {},
                outlinedPrimary: isDark2 ? {
                    color: '#8fa6b0',
                    borderColor: '#536b76',
                    '&:hover': {
                        borderColor: '#8fa6b0',
                        backgroundColor: 'rgba(73, 104, 120, 0.14)'
                    }
                } : {},
                textPrimary: isDark2 ? {
                    color: '#8fa6b0',
                    '&:hover': {
                        backgroundColor: 'rgba(73, 104, 120, 0.14)'
                    }
                } : {},
                sizeSmall: {
                    fontSize: '0.7rem'
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '16px 16px 8px 16px'
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '8px 16px'
                }
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                minHeight: 32
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    height: 24
                }
            }
        }
    }
    });
}

export const ThemeBlue = createTheme(getThemeStyles('light'));
export const ThemeBlueDark = createTheme(getThemeStyles('dark'));
export const ThemeBlueDark2 = createTheme(getThemeStyles('dark2'));

export function getThemeForMode(mode) {
    if (mode === 'dark') return ThemeBlueDark;
    if (mode === 'dark2') return ThemeBlueDark2;
    return ThemeBlue;
}